import Component_HelloReact_ea04f56c4faf9ddfa43c9392b1d0d16b from "../../../../content/guides/react-cra/HelloReact";
import Devtool_HelloReact_ea04f56c4faf9ddfa43c9392b1d0d16b from "!!@devtool/loader!../../../../content/guides/react-cra/HelloReact";
import { DevTool } from '@devtool/react';
import * as React from 'react';
export default {
  Component_HelloReact_ea04f56c4faf9ddfa43c9392b1d0d16b,
  Devtool_HelloReact_ea04f56c4faf9ddfa43c9392b1d0d16b,
  DevTool,
  React
};